export class Expirable<T> {
    private value?: T;
    private promise?: Promise<T>;
    private valueAt?: number;

    constructor(private fetch: () => Promise<T>, private maxAgeMS: number ){}

    get = async (): Promise<T> => {
        // if a promise is in flight, use it
        if (this.promise){
            return this.promise;
        }

        // if it is expired, get a promise in flight and return that
        if (this.valueAt && Date.now() - this.valueAt > this.maxAgeMS){
            return this.createNewPromise();
        }

        // if it isn't expired, use it
        if (this.value){
            return this.value;
        }

        return this.createNewPromise();
    }

    private createNewPromise = (): Promise<T> => {
        this.promise = Promise.resolve()
            .then(() => {
                return this.fetch();
            })
            .then(val => {
                this.value = val;
                this.valueAt = Date.now();
                this.promise = undefined;
                return val;
            }, err => {
                this.promise = undefined;
                throw err;
            });
        return this.promise;
    }
}
